var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0082 3C15.4302 3.0005 19.0142 6.58608 19.0142 11.0082C19.014 12.766 18.4468 14.3908 17.4863 15.7115C17.4195 15.8034 17.4296 15.931 17.5099 16.0113L20.6898 19.1911C21.1033 19.6049 21.1035 20.2761 20.6898 20.6898C20.2761 21.1035 19.6049 21.1033 19.1911 20.6898L16.0113 17.5099C15.951 17.4497 15.8641 17.4285 15.7859 17.4502L15.7115 17.4863C14.3908 18.4468 12.766 19.014 11.0082 19.0142C6.58608 19.0142 3.0005 15.4302 3 11.0082C3 6.5858 6.5858 3 11.0082 3ZM11.0082 5.11953C7.75616 5.11953 5.11953 7.75616 5.11953 11.0082C5.12003 14.2599 7.75645 16.8958 11.0082 16.8958C14.2596 16.8953 16.8953 14.2596 16.8958 11.0082C16.8958 7.75645 14.2599 5.12003 11.0082 5.11953Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9a0d110800b1455e0c893cac6392ac12.svg";
export { ForwardRef as ReactComponent };